export enum PermissionLevel {
  // can read properties and attributes (Read)
  Read = 1,
  // can add/remove properties and update attributes (Read/ Write)
  Write = 2,
  // admin or owner (Owner)
  Owner = 3,
}
